import type { WeekDays } from "@/types/common"

export const WEEK_DAYS: WeekDays[] = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]

/** Fallback appointment duration (minutes) when the doctor's profile has no average configured. */
export const DEFAULT_VISIT_DURATION_MINUTES = 30

export const ICONS = {
	status: {
		pregnancy: "cil:pregnant",
		menopause: "carbon:sunset",
		fertility: "carbon:gender-female",
		abortion: "carbon:rain-drop",
		post_partum: "ph:baby",
		unknown: "carbon:help"
	},
	delivery_date_type: {
		assumed: "mdi:calendar-question-outline",
		c_section: "carbon:scalpel"
	},
	delivery_type: {
		natural: "carbon:apple",
		c_section: "carbon:scalpel"
	},
	date: "carbon:calendar",
	delivery: "jm:birth",
	mother_weight: "hugeicons:weight-scale",
	fetus_weight: "hugeicons:weight-scale-01",
	twins: "carbon:user-multiple",
	gestational_period: "jm:fetus",
	gender: {
		male: "carbon:gender-male",
		female: "carbon:gender-female",
		unknown: "carbon:help"
	},
	tools: {
		pregnancy_calculator: "carbon:chart-bullet",
		monitoring: "carbon:calendar-heat-map",
		doppler: "carbon:chart-median",
		biometry: "carbon:chart-evaluation"
	},
	pages: {
		dashboard: "carbon:dashboard",
		patients: "carbon:person",
		calendar: "carbon:calendar",
		chat: "carbon:chat",
		profile: "ion:person-outline",
		logout: "ion:log-out-outline",
		settings: "carbon:settings"
	}
}
